/**
 * @typedef {Object} ToothPartsModel
 * @property {string} toothGumType - The type of tooth gum (UPPER or LOWER)
 * @property {number} toothIndex - The index of the tooth
 * @property {string} toothPartsType - The type of tooth parts (ATTACH, BITESTOP, CUTOUT, HOOK, SLIT)
 * @property {string} fileUrl - The URL of the file
 */

import {
  TOOTH_GUM_TYPE_KEY,
  TOOTH_NUMBER_KEY,
  TOOTH_PARTS_TYPE_KEY,
} from "../constant/toothConstant";
import toothNumberDB from "../db/toothNumberDB";
import toothPartsDB from "../db/toothPartsDB";
import { modelLoad } from "../util/modelLoader";
import { addPerform } from "../../tools/perform-tool";
const toothPartsModelListSingle = [];

const toothPartsModelMapSingle = {};

const loadToothPartsModel = async (toothPartsDOList) => {
  const toothPartsModelPromiseList = toothPartsDOList.map((toothPartsDO) => {
    return modelLoad(toothPartsDO.fileUrl, toothPartsDO.filePath);
  });
  const toothPartsModelResultList = await Promise.all(
    toothPartsModelPromiseList
  );

  // const toothPartsModelResultListWithNormal = toothPartsModelResultList.map((model) => {
  //   model.deleteAttribute("normal");
  //   model.computeVertexNormals(true);
  //   return model;
  // });

  toothPartsModelResultList.forEach((model) => {
    const normalAttribute = model.getAttribute("normal");
    if (!normalAttribute) {
      model.computeVertexNormals(true);
    }
  });

  return toothPartsModelResultList;
};

const loadToothPartsModelList = async () => {
  const toothPartsDOList = toothPartsDB.getToothPartsDOList();
  const toothPartsModelResultList = await loadToothPartsModel(toothPartsDOList);

  for (let i = 0; i < toothPartsDOList.length; i++) {
    const toothPartsDO = toothPartsDOList[i];
    const { toothGumType, toothIndex, toothPartsType } = toothPartsDO;
    const toothNumber = toothNumberDB.getToothNumberByGumTypeAndToothIndex(
      toothGumType,
      toothIndex
    );

    if (!toothNumber || !toothIndex || !toothGumType) {
      throw new Error(
        `Tooth number not found for toothGumType: ${toothGumType}, toothIndex: ${toothIndex}`
      );
    }

    const toothPartsModel = {
      toothGumType,
      toothNumber,
      toothIndex,
      toothPartsType,
      model: toothPartsModelResultList[i],
    };

    const toothNumberKey = `${TOOTH_NUMBER_KEY}:${toothNumber}`;
    const toothPartsTypeKey = `${TOOTH_PARTS_TYPE_KEY}:${toothPartsType}`;

    if (!toothPartsModelMapSingle[toothNumberKey]) {
      toothPartsModelMapSingle[toothNumberKey] = {};
    }

    toothPartsModelMapSingle[toothNumberKey][toothPartsTypeKey] =
      toothPartsModel;
    toothPartsModelListSingle.push(toothPartsModel);
  }
};

const getToothPartsModelList = () => {
  return toothPartsModelListSingle;
};

const getToothPartsModelListByToothNumber = (toothNumber) => {
  const toothNumberKey = `${TOOTH_NUMBER_KEY}:${toothNumber}`;
  const toothPartsTypeMap = toothPartsModelMapSingle[toothNumberKey];

  if (!toothPartsTypeMap) {
    return [];
  }

  return Object.values(toothPartsTypeMap);
};

export default {
  loadToothPartsModelList,
  getToothPartsModelList,
  getToothPartsModelListByToothNumber,
};
